import { QueryClient } from "@tanstack/react-query";

/**
 * The single query cache, module-level rather than built in `main.tsx` so that
 * non-React code can reach it — logging out has to empty it, or the next
 * session would be handed the previous one's data out of cache before its own
 * requests land.
 */
export const queryClient = new QueryClient({
  // Map-adjacent data barely changes; long stale times keep panel interactions
  // from re-firing requests the user cannot perceive the result of.
  defaultOptions: {
    queries: { staleTime: 5 * 60_000, refetchOnWindowFocus: false, retry: 1 },
  },
});
